/* CreateVendor.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button/new';
import { useFlags } from '@atlaskit/flag';
import Form, { FormFooter } from '@atlaskit/form';
import { media } from '@atlaskit/primitives/responsive';
import SectionMessage from '@atlaskit/section-message';
import { H1 } from '@atlassian/amkt-common';
import { getFlagForError } from '@atlassian/developer-space';
import { FluidContainer } from '@atlassian/mpac-primitives';
import { useRef, useState } from 'react';
import { API_STATUS_ERROR_MESSAGE, GENERIC_ERROR_MESSAGE } from '../../ManagePartners/constants/ErrorMessages';
import { buildFormErrorMessage, mapVendorCreateErrorsToFields, VENDOR_CREATION_MESSAGE } from './ManageVendorCreate.utils';
import { ContactAddress } from './sections/ContactAddress';
import { ContactDetails } from './sections/ContactDetails';
import { SupportContactDetails } from './sections/SupportContactDetails';
import { SupportDetails } from './sections/SupportDetails';
import { SupportHours } from './sections/SupportHours';
import { VendorDetailsSection } from './sections/VendorDetailsSection';
import defaultGreyIcon from '../images/icon-default-grey.png';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const _22 = "@media (min-width:48rem){._1r3v1epz{padding-left:var(--ds-space-1000,5pc)}}";
const _21 = "._19bvidpf{padding-left:0}";
const _20 = "._1yt4v47k{padding:var(--ds-space-250,20px)}";
const _19 = "@media not all and (min-width:30rem){._1qjnviql{font-size:2rem}}";
const _18 = "._18u0idpf{margin-left:0}";
const _17 = "._otyridpf{margin-bottom:0}";
const _16 = "._2hwxidpf{margin-right:0}";
const _15 = "._19pkidpf{margin-top:0}";
const _14 = "@media not all and (min-width:30rem){._1qwo1wto{width:3rem}._15sj1wto{height:3rem}}";
const _13 = "._5ral1dfr{object-fit:cover}";
const _12 = "._4t3i12bs{height:4rem}";
const _11 = "._1bsb12bs{width:4rem}";
const _10 = "@media not all and (min-width:30rem){._1wm0u2gc{gap:var(--ds-space-100,8px)}}";
const _9 = "._p12f18kn{max-width:61.25rem}";
const _8 = "._2hwx1wug{margin-right:auto}";
const _7 = "._18u01wug{margin-left:auto}";
const _6 = "._4cvr1h6o{align-items:center}";
const _5 = "._1e0c1txw{display:flex}";
const _4 = "._zulputpp{gap:var(--ds-space-150,9pt)}";
const _3 = "._1yt4ab66{padding:var(--_1wi0g9c)}";
const _2 = "._1bsb1osq{width:100%}";
const _ = "._n7zlpp12{border-bottom:var(--_18x9sjc)}";
const CreateVendorHeaderFullBleed = null;
const CreateVendorHeader = null;
const CreateVendorHeaderInner = null;
const ImageContainer = null;
const CreateVendorHeading = null;
const CreateVendorFormContainer = null;
const LeftPadding = null;
export default function CreateVendor() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoError, setLogoError] = useState(null);
  const [formError, setFormError] = useState(null);
  const [submissionErrors, setSubmissionErrors] = useState({});
  const errorSummaryRef = useRef(null);
  const {
    showFlag
  } = useFlags();
  const handleSubmit = async data => {
    setIsSubmitting(true);
    setFormError(null);
    setSubmissionErrors({});
    try {
      console.log('Creating vendor with data:', data);
    } catch (error) {
      try {
        var _errorsArray;
        // Try to parse server response errors
        const errorResponse = error === null || error === void 0 ? void 0 : error.error;
        let errorsArray;
        if (errorResponse && typeof errorResponse.json === 'function') {
          const parsed = await errorResponse.json();
          errorsArray = parsed === null || parsed === void 0 ? void 0 : parsed.errors;
        }
        const fieldErrors = mapVendorCreateErrorsToFields(errorsArray);
        setSubmissionErrors(fieldErrors);

        // Build form-level message
        const status = error === null || error === void 0 ? void 0 : error.status;
        const formMsg = buildFormErrorMessage(status, (_errorsArray = errorsArray) === null || _errorsArray === void 0 ? void 0 : _errorsArray.filter(e => !(e !== null && e !== void 0 && e.path)).map(e => (e === null || e === void 0 ? void 0 : e.message) || '').filter(Boolean), {
          generic: GENERIC_ERROR_MESSAGE,
          byStatus: API_STATUS_ERROR_MESSAGE
        });
        setFormError(formMsg);

        // Show global flag
        showFlag(getFlagForError('vendor-create-failure', formMsg));
      } catch (e) {
        const fallbackMsg = GENERIC_ERROR_MESSAGE;
        setFormError(fallbackMsg);
        showFlag(getFlagForError('vendor-create-failure', fallbackMsg));
      }
    } finally {
      setIsSubmitting(false);
      // Focus error summary for accessibility if present
      setTimeout(() => {
        if (errorSummaryRef.current) {
          errorSummaryRef.current.focus();
        }
      }, 0);
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CreateVendorHeaderView, {}), /*#__PURE__*/_jsx(CreateVendorFormView, {
      isSubmitting: isSubmitting,
      formError: formError,
      submissionErrors: submissionErrors,
      errorSummaryRef: errorSummaryRef,
      handleSubmit: handleSubmit,
      logoPreview: logoPreview,
      setLogoPreview: setLogoPreview,
      logoError: logoError,
      setLogoError: setLogoError
    })]
  });
}
function CreateVendorHeaderView() {
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_n7zlpp12 _1bsb1osq"]),
      style: {
        "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
      },
      children: /*#__PURE__*/_jsx(FluidContainer, {
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_3]
          }), /*#__PURE__*/_jsx("header", {
            className: ax(["_1yt4ab66"]),
            style: {
              "--_1wi0g9c": ix("var(--ds-space-250, 20px)".concat(" 0"))
            },
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_4, _5, _6, _7, _8, _2, _9, _10]
              }), /*#__PURE__*/_jsxs("div", {
                className: ax(["_zulputpp _1e0c1txw _4cvr1h6o _18u01wug _2hwx1wug _1bsb1osq _p12f18kn _1wm0u2gc"]),
                children: [/*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_11, _12, _13, _14]
                  }), /*#__PURE__*/_jsx("img", {
                    src: defaultGreyIcon,
                    alt: "Create Vendor",
                    className: ax(["_1bsb12bs _4t3i12bs _5ral1dfr _1qwo1wto _15sj1wto"])
                  })]
                }), /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_15, _16, _17, _18, _19]
                  }), /*#__PURE__*/_jsx(H1, {
                    className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1qjnviql"]),
                    children: "Create Vendor"
                  })]
                })]
              })]
            })
          })]
        })
      })
    })]
  });
}
function CreateVendorFormView(_ref) {
  let {
    isSubmitting,
    formError,
    submissionErrors,
    errorSummaryRef,
    handleSubmit,
    logoPreview,
    setLogoPreview,
    logoError,
    setLogoError
  } = _ref;
  return /*#__PURE__*/_jsx(FluidContainer, {
    children: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_20, _9, _7, _8]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_1yt4v47k _p12f18kn _18u01wug _2hwx1wug"]),
        children: [/*#__PURE__*/_jsx(SectionMessage, {
          testId: "create-vendor-info-message",
          children: /*#__PURE__*/_jsx("p", {
            children: VENDOR_CREATION_MESSAGE
          })
        }), /*#__PURE__*/_jsx(Form, {
          onSubmit: handleSubmit,
          children: _ref2 => {
            let {
              formProps,
              submitting,
              setFieldValue
            } = _ref2;
            return /*#__PURE__*/_jsxs("form", _objectSpread(_objectSpread({
              noValidate: true
            }, formProps), {}, {
              children: [formError && /*#__PURE__*/_jsx("div", {
                ref: errorSummaryRef,
                tabIndex: -1,
                children: /*#__PURE__*/_jsx(SectionMessage, {
                  appearance: "error",
                  testId: "form-error-summary",
                  children: /*#__PURE__*/_jsx("p", {
                    role: "alert",
                    "aria-live": "assertive",
                    children: formError
                  })
                })
              }), /*#__PURE__*/_jsx(VendorDetailsSection, {
                logoPreview: logoPreview,
                setLogoPreview: setLogoPreview,
                logoError: logoError,
                setLogoError: setLogoError,
                submissionErrors: submissionErrors
              }), /*#__PURE__*/_jsx(ContactAddress, {
                submissionErrors: submissionErrors
              }), /*#__PURE__*/_jsx(ContactDetails, {
                submissionErrors: submissionErrors
              }), /*#__PURE__*/_jsx(SupportDetails, {
                submissionErrors: submissionErrors
              }), /*#__PURE__*/_jsx(SupportHours, {
                setFieldValue: setFieldValue
              }), /*#__PURE__*/_jsx(SupportContactDetails, {
                submissionErrors: submissionErrors
              }), /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_21, _22]
                }), /*#__PURE__*/_jsx("div", {
                  className: ax(["_19bvidpf _1r3v1epz"]),
                  children: /*#__PURE__*/_jsx(FormFooter, {
                    align: "start",
                    children: /*#__PURE__*/_jsx(Button, {
                      appearance: "primary",
                      type: "submit",
                      isLoading: submitting || isSubmitting,
                      children: "Create vendor"
                    })
                  })
                })]
              })]
            }));
          }
        })]
      })]
    })
  });
}